/* ─── Room Type Filter Options (UI Config) ─────────────────────────── */

export const ROOM_TYPE_FILTERS = ['All', 'Standard', 'Deluxe', 'Suite'] as const;
